module.exports = __webpack_public_path__ + "static/img_2253-55bc9c6e687156ef246d19115690a328.webp";